import Vue from 'vue'
import App from './App.vue'
import './style/reset.css'
import router from './router'//引入路由
import VueAwesomeSwiper from 'vue-awesome-swiper';
import'swiper/css/swiper.css'; // 引入 Swiper 样式
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'olgQO8wnQH9MKBqT099jLXVubQ2uz08U' // 百度地图秘钥
})

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper);
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
